import React from 'react';
import { RefreshControl, SectionList, View } from 'react-native';
import type { TDocumentsListProps } from '../../types';
import { DocumentRow } from '../cards';
import { DocumentsEmpty, DocumentsMonthTitle } from '../layout';

const ItemSeparator = () => <View className="h-sm" />;

export const DocumentsList = ({
    sections,
    doctorGender,
    openingId,
    isRefreshing,
    onRefresh,
    onPressItem,
}: TDocumentsListProps) => (
    <SectionList
        sections={sections}
        keyExtractor={item => `${item.kind}-${item.id}`}
        stickySectionHeadersEnabled={false}
        ItemSeparatorComponent={ItemSeparator}
        renderSectionHeader={({ section }) => <DocumentsMonthTitle title={section.title} />}
        renderItem={({ item }) => (
            <DocumentRow
                item={item}
                doctorGender={doctorGender}
                isOpening={openingId === item.id}
                onPress={() => onPressItem(item)}
            />
        )}
        ListEmptyComponent={<DocumentsEmpty />}
        refreshControl={<RefreshControl refreshing={isRefreshing} onRefresh={onRefresh} />}
        contentContainerClassName="grow px-md pb-md"
    />
);
